import { BuilderBlockProps, CallbackReturnType } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { Blocks } from "@builder.io/sdk-react";
import { FC, useEffect } from "react";

type ApiWrapperBlockProps = {
  onInitialize?: () => CallbackReturnType;
} & BuilderProps &
  BuilderBlockProps;

export const ApiWrapperBlock: FC<ApiWrapperBlockProps> = ({
  onInitialize,
  builderBlock,
  builderComponents,
  builderContext,
  builderLinkComponent,
}) => {
  useEffect(() => {
    if (onInitialize) {
      onInitialize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {builderBlock.children?.map((block, index) => (
        <Blocks
          key={block.id || index}
          parent={builderBlock?.id}
          registeredComponents={builderComponents}
          linkComponent={builderLinkComponent}
          context={builderContext}
          path={`apiWrapper.${index}`}
          blocks={[block]}
        />
      ))}
    </>
  );
};
